import React from "react";
import { Container } from "react-bootstrap";

const ContactForm = () => {
  return (
    <Container>
      <div id="contact" className="anchor"></div>
      <div className="contact-form">
        <h2>
          <span>Interested?</span> <br />
          Fill out a rental application.
        </h2>
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <a
            href="https://nicodi.managebuilding.com/Resident/rental-application/new"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              backgroundColor: "#323232",
              color: "#f3f3f3",
              fontFamily: "'Lora', serif",
              fontSize: "20pt",
              fontWeight: "600",
              padding: "20px 80px",
              borderRadius: "4px",
              textDecoration: "none",
              letterSpacing: "0.08em",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#1a1a1a"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#323232"}
          >
            Apply Now
          </a>
        </div>
      </div>
    </Container>
  );
};

export default ContactForm;
